export default __webpack_public_path__ + "static/media/83.06376f98.jpeg";